import * as THREE from "three"
import React, { useEffect } from "react"
import { useLoader } from "react-three-fiber"
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader"
import { ModelRenderer } from "./ModelRenderer"
// import modelTexture from "./assets/neeraj_texture_opt.jpg"
// const MODEL_BASE_URL = "./"
const MODEL_BASE_URL = "https://nsharma1396.s3.ap-south-1.amazonaws.com" // "https://neeraj1396.s3.us-east-2.amazonaws.com"

function SelfModel({ mouse, onLoad, showModel }) {
  const { nodes, animations, scene } = useLoader(
    GLTFLoader,
    `${MODEL_BASE_URL}/neeraj_mdl.gltf`
  )

  const texture = useLoader(
    THREE.TextureLoader,
    // modelTexture
    `${MODEL_BASE_URL}/neeraj_texture_updated.jpg`
  )

  useEffect(() => {
    onLoad("model", {
      nodes,
      animations,
      texture,
      scene,
    })
  }, [animations, nodes, onLoad, texture, scene])

  return (
    <ModelRenderer
      nodes={nodes}
      texture={texture}
      scene={scene}
      animations={animations}
      mouse={mouse}
      showModel={showModel}
    />
  )
}

export default SelfModel

// /**
//  * @description without useLoader
//  */
// import * as THREE from "three"
// import React, { useEffect, useMemo, useState } from "react"
// import { useLoader } from "react-three-fiber"
// import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader"
// import { ModelRenderer } from "./ModelRenderer"

// const MODEL_BASE_URL = "./"
// // const MODEL_BASE_URL = "https://neeraj1396.s3.us-east-2.amazonaws.com"

// function SelfModel({ mouse, onLoad, showModel }) {
//   const [gltfData, updateGltfData] = useState({ status: "loading" })
//   // const { nodes, animations, scene } = useLoader(
//   //   GLTFLoader,
//   //   `${MODEL_BASE_URL}/neeraj.gltf`
//   // )
//   useEffect(() => {
//     async function loadData() {
//       const { gltf, texture } = await loadModel()
//       onLoad("model", {
//         scene: gltf.scene,
//         animations: gltf.animations,
//         texture,
//       })
//       updateGltfData({
//         scene: gltf.scene,
//         animations: gltf.animations,
//         texture,
//         status: "success",
//       })
//     }
//     loadData()
//   }, [])

//   // const texture = useLoader(
//   //   THREE.TextureLoader,
//   //   `${MODEL_BASE_URL}/Neeraj_Packed0_Diffuse_png-Neeraj_Packed0_Diffuse_png.png`
//   // )

//   // useEffect(() => {
//   //   onLoad("model", {
//   //     animations: gltf.animations,
//   //     texture: texture,
//   //     scene: gltf.scene,
//   //   })
//   // }, [texture, gltf])

//   return gltfData.status === "success" ? (
//     <ModelRenderer
//       // nodes={nodes}
//       // texture={texture}
//       // scene={scene}
//       // animations={animations}
//       {...gltfData}
//       mouse={mouse}
//       showModel={showModel}
//     />
//   ) : null
// }

// export default SelfModel
// function loadModel() {
//   return new Promise((resolve, reject) => {
//     let result = {}
//     new GLTFLoader().load(`${MODEL_BASE_URL}/neeraj.gltf`, gltf => {
//       result.gltf = gltf
//       new THREE.TextureLoader().load(
//         `${MODEL_BASE_URL}/Neeraj_Packed0_Diffuse_png-Neeraj_Packed0_Diffuse_png.png`,
//         texture => {
//           result.texture = texture
//           resolve(result)
//         }
//       )
//     })
//   })
// }
